module.exports = "/_next/static/images/PersonalizationEngine-81509f5eb8cfb9328371d0118a78c49a.webp";